import { useState } from "react";
import { ProductGrid } from "../components/product";
import { SEO } from "../components/SEO";

export default function ShopPage({ products }) {
  const [filter, setFilter] = useState("all");
  const filteredProducts = filter === "all" ? products : products.filter(p => p.category.toLowerCase() === filter);

  return (
    <div className="min-h-screen bg-black pt-28 pb-12 px-4" data-testid="shop-page">
      <SEO title="Shop All Products" description="Shop all Fresh Po'Boy streetwear. T-Shirts, Hoodies, Sweaties. Hip Hop, Faith, Sports, Anime & more. 10% OFF everything." path="/shop" />
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8">
          <h1 className="text-white text-5xl sm:text-6xl font-bebas">Shop All</h1>
        </div>
        
        {/* Brand Intro */}
        <div className="max-w-3xl mx-auto text-center mb-12">
          <p className="text-white/70 text-lg leading-relaxed">
            Welcome to <span className="text-cyan-400 font-semibold">Fresh Po'Boy Wear</span> — where bold faith meets real culture. 
            Every piece is crafted with premium heavy cotton and designed to make a statement without saying a word. 
            <span className="text-red-500 font-semibold"> This isn't just clothing. It's confidence you can wear.</span>
          </p>
        </div>
        
        <div className="flex justify-center gap-4 mb-12">
          <button 
            onClick={() => setFilter("all")} 
            className={`px-6 py-2 ${filter === "all" ? 'bg-red-600 text-white' : 'bg-zinc-800 text-white hover:bg-zinc-700'} transition-colors`}
            data-testid="filter-all"
          >
            All
          </button>
          <button 
            onClick={() => setFilter("t-shirts")} 
            className={`px-6 py-2 ${filter === "t-shirts" ? 'bg-red-600 text-white' : 'bg-zinc-800 text-white hover:bg-zinc-700'} transition-colors`}
            data-testid="filter-tshirts"
          >
            T-Shirts
          </button>
          <button 
            onClick={() => setFilter("hoodies")} 
            className={`px-6 py-2 ${filter === "hoodies" ? 'bg-red-600 text-white' : 'bg-zinc-800 text-white hover:bg-zinc-700'} transition-colors`}
            data-testid="filter-hoodies"
          >
            Hoodies
          </button>
        </div>
        <ProductGrid products={filteredProducts} />
      </div>
    </div>
  );
}
